import type { StateStore } from "../app/state/StateStore";

import { BaseBlock } from "./BaseBlock";

/**
 * Первый блок NoticeScreen.
 *
 * Показывает сообщение о завершении курса
 * или переходе к следующему Krok.
 */
export class NoticeHeaderBlock extends BaseBlock {

constructor(
    private readonly store: StateStore,
    private readonly onOpenKrok: (krokId: string) => void
) {
        super();
    }

    public override mount(): void {

        this.root =
            this.render();

    }

    public override update(): void {

        const newRoot =
            this.render();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {
        super.unmount();
    }

    private render(): HTMLElement {

        const wrapper =
            document.createElement("div");

        wrapper.className =
            "task explanation-task notice-center";

        const state =
            this.store.getState();

        if (state.primaryScreen.type !== "notice") {
            return wrapper;
        }

        const text =
            document.createElement("p");

        text.style.textAlign =
            "center";

        switch (state.primaryScreen.noticeType) {

            case "next_available":

                text.innerHTML =
                    "<b>Чудово!</b> Ви завершили цей Крок.";

                wrapper.appendChild(text);

                const button =
                    document.createElement("button");

                button.textContent =
                    "Перейти до наступного Кроку";

                button.style.display =
                    "block";

                button.style.margin =
                    "24px auto 0 auto";

                button.addEventListener(
                    "click",
                    () => {

                        const krokId =
                            state.primaryScreen.nextKrokId;

                        if (krokId) {

                            this.onOpenKrok(
                                krokId
                            );

                        }

                    }
                );
                wrapper.appendChild(button);

                break;

            case "locked":

                text.innerHTML =
                    "Чудово! Ви вже пройшли всі доступні вам на сьогодні кроки. Новий крок відкриється завтра.";

                wrapper.appendChild(text);

                break;

            case "finished":

                text.innerHTML =
                    "Вітаємо! Ви успішно завершили цей курс.";

                wrapper.appendChild(text);

                break;

        }

        return wrapper;

    }

}